import React, { useState, useEffect } from "react";
import { AddCircle } from "@mui/icons-material";
import { Container, Grid, CircularProgress, useTheme } from "@mui/material";
import { SupervisedUserCircleRounded } from "@mui/icons-material";
import { BasicButton } from "../../../../components/BasicButton";
import { PortalScreenHeader } from "../../../../components/PortalScreenHeader";
import { UsersTable } from "./components/UsersTable";
import { UsersService } from "../../../../services/supabase/UsersService";
import { userRolesStore } from "../../../../app/stores/UserRoles";
import { PermissionWrapper } from "../../../../components/PermissionWrapper";

const Users: React.FC = () => {
    const theme = useTheme();
    const { getAllUsers } = UsersService();
    const { users, isLoading } = userRolesStore();

    useEffect(() => {
        getAllUsers();
    }, []);

    // Future: Add user creation functionality
    const handleCreateUser = () => {
        // TODO: Implement user creation dialog
        console.log("Create user functionality - coming soon");
    };

    return (
        <PermissionWrapper screen="users" permission="view">
        <Container
            component="main"
            maxWidth="xl"
            sx={{
                height: "100%",
                paddingX: { xs: 0, md: 2 },
            }}>
            {
                isLoading && users.length === 0 ?
                    <Grid container justifyContent="center" mt={20}>
                        <Grid item>
                            <CircularProgress
                                size={40}
                                sx={{ color: theme.palette.primary.main }}
                            />
                        </Grid>
                    </Grid>
                    :
                    <>
                        <PortalScreenHeader
                            title="User Management"
                                subtitle="Manage user accounts and roles"
                            icon={<SupervisedUserCircleRounded />}
                                mobileActionIcon={<AddCircle />}
                                onMobileActionClick={handleCreateUser}
                            actions={
                                <PermissionWrapper screen="users" permission="create">
                                    <BasicButton
                                        title="Create User"
                                        onClick={handleCreateUser}
                                        startIcon={<AddCircle />}
                                    />
                                </PermissionWrapper>
                            }
                        />
                        <UsersTable
                            users={users}
                        />
                    </>
            }
        </Container>
        </PermissionWrapper>
    );
};

export default Users;
